import { Component, EventEmitter, inject, Input, Output, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ApiService } from '../../api.service';
import { ButtonModule } from 'primeng/button';
import { MatIcon } from '../mat-icon/mat-icon';

@Component({
  selector: 'document-grid',
  imports: [ButtonModule, MatIcon, TranslatePipe],
  providers: [],
  templateUrl: './document-grid.html',
  styleUrl: './document-grid.scss',
})
export class DocumentGridComponent {
  private api = inject(ApiService);

  @Input() documents: { fileName: string; mimeType: string; fileData?: Blob; }[] = [];
  @Input() urlTemplate: string = '';
  @Input() showUpload: boolean = false;
  @Input() showDownload: boolean = false;
  @Input() showView: boolean = false;
  @Input() showDelete: boolean = false;

  @Output() uploadClicked = new EventEmitter<{ fileName: string, mimeType: string, fileData: string }>();
  @Output() deleteClicked = new EventEmitter<string>();

  loading = signal(false);

  isDragOver = false;
  private dragCount = 0;

  constructor() { }

  fileUrl(fileName: string) {
    let doc = this.documents.find((d) => d.fileName == fileName);
    if (doc && doc.fileData) {
      return doc.fileData;
    }

    return this.urlTemplate.replace('<filename>', fileName);
  }

  fileIcon(mimeType: string) {
    switch (mimeType) {
      case "image/png":
      case "image/jpeg":
        return "image";
      case "application/pdf":
        return "article";
      default:
        return "unknown_document";
    }
  }

  uploadFile(event: HTMLInputElement) {
    const files = event.files ?? null;

    if (files == null || files.length == 0) {
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      let file = files[0];
      let fileData = reader.result as string;

      let fileName = file.name.replace(/[^a-zA-Z0-9.]/g, '_');
      let mimeType = file.type;

      console.log('New File Name ' + fileName);

      this.uploadClicked.emit({ fileName: fileName, mimeType: mimeType, fileData: fileData });
    };

    reader.readAsDataURL(files[0]);
  }

  onDragEnter(event: DragEvent) {
    console.log('[document-grid] dragenter showUpload=' + String(this.showUpload) + ' count=' + this.dragCount);
    if (!this.showUpload) {
      return;
    }
    event.preventDefault();
    this.dragCount++;
    this.isDragOver = true;
  }

  onDragOver(event: DragEvent) {
    console.log('[document-grid] dragover showUpload=' + String(this.showUpload) + ' count=' + this.dragCount + ' over=' + String(this.isDragOver));
    if (!this.showUpload) {
      return;
    }
    event.preventDefault();
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent) {
    console.log('[document-grid] dragleave showUpload=' + String(this.showUpload) + ' count=' + this.dragCount);
    if (!this.showUpload) {
      return;
    }
    event.preventDefault();
    this.dragCount--;
    if (this.dragCount <= 0) {
      this.dragCount = 0;
      this.isDragOver = false;
    }
  }

  onDrop(event: DragEvent) {
    console.log('[document-grid] drop showUpload=' + String(this.showUpload) + ' files=' + String(event.dataTransfer?.files?.length ?? 0));
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;

    if (!this.showUpload) {
      return;
    }

    const files = event.dataTransfer?.files ?? null;
    if (files == null || files.length == 0) {
      console.log('[document-grid] drop: no files to upload');
      return;
    }
    for (const file of files) {
      console.log('[document-grid] uploading', file.name);
      this.uploadSingle(file);
    }
  }

  private uploadSingle(file: File) {
    if (!file) {
      console.log('[document-grid] uploadSingle: no file received');
      return;
    }
    const reader = new FileReader();
    reader.onloadend = () => {
      let fileData = reader.result as string;
      console.log('[document-grid] onloadend resultLen=' + String(fileData?.length ?? 0));

      let fileName = file.name.replace(/[^a-zA-Z0-9.]/g, '_');
      let mimeType = file.type;

      this.uploadClicked.emit({ fileName: fileName, mimeType: mimeType, fileData: fileData });
      console.log('[document-grid] emit fired for ' + fileName);
    };
    reader.onerror = () => {
      console.log('[document-grid] FILEREAD ERROR for ' + file.name, reader.error);
    };
    reader.readAsDataURL(file);
  }

  deleteFile(fileName: string) {
    this.deleteClicked.emit(fileName);
  }

  downloadDoc(fileName: string, download: boolean = false) {
    if (this.loading()) return;
    this.loading.set(true);

    let url = this.fileUrl(fileName);
    if (typeof url == 'string') {
      this.api
        .getDocumentByUrl(url)
        .then((data) => {
          console.log(data);
          this.promptDownload(fileName, data, download);
          this.loading.set(false);
        })
        .catch((reason) => {
          console.log(reason);
        });
      } else {
        this.promptDownload(fileName, url, download);
        this.loading.set(false);
    }
  }

  promptDownload(fileName: string, data: Blob, download: boolean = false) {
    var pdfUrl = window.URL.createObjectURL(data);

    var link = document.createElement('a');
    link.download = fileName;
    link.href = pdfUrl;

    console.log(link);

    if (download) {
      link.click();
    } else {
      window.open(pdfUrl, '_blank');
    }
  }
}
